import { Typography } from "@mui/material";


function SectionTitle(_props) {

  const {
    title = "title prop is missing",
    children
  } = _props;

  return (
    <div className="flex flex-row justify-between items-center mb-12">
      <Typography variant="h1" className="">
        {title}
      </Typography>
      <div className="flex flex-row gap-4 items-center">
        {children}
      </div>
    </div>
  )
}

export default SectionTitle;